import script from "./SearcherFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./SearcherFiles.vue?vue&type=script&setup=true&lang=js"

import "./SearcherFiles.vue?vue&type=style&index=0&id=f3e3c124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3e3c124"]])

export default __exports__